// latest: zhangmyh 2017-8-14 10:20 AM
// 销售类型参照
/* global $ u */
import { Collection, Get, URLs } from 'common'
import 'collection/saleClass'
import { findIndex } from 'lodash'

const PURCHASEID = window.global.user.PURCHASEID
let _config
function init (refer) {
  // 树形控件加载有误,所以需要每次都重新加载
  let trees = Collection.create('collection.saleclass')
  let saleclass = Collection.create('collection.saleclass')
  let selectItem = null

  if (_config.multiSelect && !_config.repeatable && refer.options.defaultData) {
    saleclass.load({}, { localData: {
      result: refer.options.defaultData()
    }})
  }

  let vm = {
    treemodel: trees.datatable,
    treeOption: {
      callback: {
        beforeClick: async function (id, obj) {
          if (!obj.flag) {
            let result = await Get(URLs.sc_getclass.url, {
              entid: PURCHASEID,
              pid: obj.id
            })
            trees.datatable.addSimpleData(result.data.result)
            obj.flag = true
          }
          selectItem = obj
        }
      }
    },
    listconfig: {
      id: 'saleclass_grid',
      data: saleclass,
      type: 'grid',
      multiSelect: false,
      editable: false,
      pagination: false,
      canDrag: false,
      fields: [{
        field: 'className',
        dataType: 'String',
        title: '选中销售分类',
        width: '75%'
      }, {
        field: 'operation',
        dataType: 'action',
        title: '操作',
        width: '25%',
        item: [{
          text: '移除',
          handler (obj) {
            saleclass.datatable.removeRowByRowId(obj.row.value['$_#_@_id'])
          },
          hidden: function (obj) {
            return false
          },
          hide: function () {
            return false
          }
        }]
      }]
    },
    add: function () {
      let data = saleclass.datatable.getSimpleData()
      if (data && data.length > 0) {
        let idx = findIndex(data, ['id', selectItem.id])
        if (idx <= -1) {
          saleclass.datatable.addSimpleData({
            id: selectItem.id,
            className: selectItem.className || selectItem.name
          })
        }
      } else {
        saleclass.datatable.setSimpleData([{
          id: selectItem.id,
          className: selectItem.className || selectItem.name
        }])
      }
    },
    remove: function () {
      let row = saleclass.datatable.getCurrentRow()
      saleclass.datatable.removeRowByRowId(row.rowId)
    }
  }

  trees.load({ entid: PURCHASEID, pid: 0 })
  let app = u.createApp()
  app.init(vm, $('#saleclassrefer')[0])

  refer.registerSubmitFunc(function () {
    return saleclass.datatable.getSimpleData()
  })
  setTimeout(function () {
    $('#saleclass_grid').css({
      height: 463,
      overflow: 'auto',
      borderBottomWidth: 1
    })
  }, 100)
}
let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    multiSelect: true
  }, config)

  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/saleClass/index.js